import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApprovalComponent } from "../approval/approval.component";
import { MatRadioChange } from "@angular/material/radio";
import { WorkFlowService } from "src/app/services/work-flow.service";
import Tagify from "@yaireo/tagify";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-evaluation",
  templateUrl: "./evaluation.component.html",
  styleUrls: ["./evaluation.component.scss"],
})
export class EvaluationComponent implements OnInit {
  form: FormGroup;
  beginid: any;
  description: string;
  formid: any;
  workflowid: any;
  nodeid: any;
  nodetype: any;
  evaluationName: any;
  evaluationDate: any;
  evaluationTime: any;
  workflowstage: any;
  formname: string;
  userapp: boolean;
  users: any = [];
  groupapp: boolean;
  groups: any = [];
  ispublished: boolean = false;
  rubrics: any;
  assessmentId: any;
  rubricId: any;
  cmbRubrics: any = [];
  slcRubrics: any;
  userList: any = [];
  userGroups: any = [];
  tagify: any;
  slcUserList: any = [];
  slcUserGroups: any = [];
  slcAppUserList: any = [];
  slcAppUserGroups: Array<{
    label: string;
    users: Array<{ id: string; name: string; email: string }>;
  }> = [];
  objData: any;
  selectedDate: any;

  constructor(
    private api: WorkFlowService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    private dialogRef: MatDialogRef<ApprovalComponent>,
    @Inject(MAT_DIALOG_DATA)
    {
      beginid,
      description,
      formid,
      workflowid,
      nodeid,
      nodetype,
      evaluationName,
      evaluationDate,
      evaluationTime,
      workflowstage,
      userapp,
      users,
      groupapp,
      groups,
      assessmentId,
      rubricId,
      rubrics,
      ispublished,
    }
  ) {
    this.description = description;
    this.formid = formid;
    this.formname = localStorage.getItem("formname");
    this.beginid = beginid;
    this.formid = formid;
    this.workflowid = workflowid;
    this.nodeid = nodeid;
    this.nodetype = nodetype;
    this.evaluationName = evaluationName;
    this.evaluationDate = evaluationDate;
    this.evaluationTime = evaluationTime;
    this.workflowstage = workflowstage;
    this.userapp = userapp;
    this.users = users;
    this.groupapp = groupapp;
    this.groups = groups;
    this.slcRubrics = rubrics;
    this.rubrics = rubrics;
    this.assessmentId = assessmentId;
    this.rubricId = rubricId;
    this.ispublished = ispublished;

    this.form = fb.group({
      beginid: [beginid],
      description: [description, Validators.required],
      formid: [formid],
      workflowid: [workflowid],
      nodeid: [nodeid],
      nodetype: [nodetype],
      evaluationName: [evaluationName, Validators.required],
      evaluationDate: [evaluationDate, Validators.required],
      evaluationTime: [evaluationTime, Validators.required],
      workflowstage: [workflowstage],
      userapp: [userapp],
      users: [users],
      groupapp: [groupapp],
      groups: [groups],
      rubrics: [],
      ispublished: [ispublished],
    });

    if (beginid !== 0) {
      let newusers = this.users;
      let newgroups = this.groups;
      this.users = [];
      this.groups = [];
      newusers.forEach((element) => {
        this.users.push(element.email);
      });

      newgroups.forEach((element) => {
        this.groups.push(element.role);
      });
    }
  }

  ngOnInit(): void {
    this.form.get("evaluationDate")?.valueChanges.subscribe((date) => {
      let slcDate: Date | null = null;
      if (date && date._d instanceof Date) {
        slcDate = date._d;
      } else if (date instanceof Date) {
        slcDate = date;
      } else if (typeof date === "string") {
        slcDate = new Date(date);
      }
      if (slcDate) {
        const userTimezoneOffset = slcDate.getTimezoneOffset() * 60000;
        const localDate = new Date(slcDate.getTime() - userTimezoneOffset);
        const formatted = localDate.toISOString().split("T")[0];
        this.selectedDate = formatted;
      }
    });
    this.getRubrics();
  }

  getUserList() {
    this.api.getUserlist(this.formid).subscribe((res: any) => {
      let users = res;
      const filteredUsers = users.filter(
        (user) =>
          !(
            user.userRoles.length === 1 &&
            user.userRoles[0] === "BillingAdministrator"
          )
      );

      for (let i = 0; i < filteredUsers.length; i++) {
        this.userList.push({
          value: filteredUsers[i].email,
          id: filteredUsers[i]._id,
          email: filteredUsers[i].email,
          name: filteredUsers[i].name,
        });
      }
      this.bindTagifyUserList(this.userList);
    });
  }
  getUserGroups() {
    this.api.getUserGroups(this.formid).subscribe((res: any) => {
      let usergroup = res;
      const filteredUserGroups = usergroup.filter(
        (group) => group.role != "BillingAdministrator"
      );
      for (let i = 0; i < filteredUserGroups.length; i++) {
        //this.userGroups.push(res[i].role);
        this.userGroups.push({
          value: filteredUserGroups[i].role,
          id: filteredUserGroups[i]._id,
          role: filteredUserGroups[i].role,
          type: filteredUserGroups[i].type,
        });
      }
      this.bindTagifyUserGroups(this.userGroups);
    });
  }

  bindTagifyUserList(data) {
    this.tagify = new Tagify(document.querySelector('[name="tagsuser"]'), {
      whitelist: data,
      enforceWhitelist: true,
      dropdown: {
        searchKeys: ["name", "email"],
        enabled: 0,
        closeOnSelect: !1,
        position: "text",
        highlightFirst: true,
      },
    });
    this.tagify.on("add", (e) => {
      this.slcAppUserGroups = [];
      this.groups = [];
      if (e.detail?.data) {
        this.slcUserList.push({
          id: e.detail?.data?.id,
          email: e.detail?.data?.email,
          name: e.detail?.data?.name,
        });
        this.slcAppUserList.push({
          id: e.detail?.data?.id,
          email: e.detail?.data?.email,
          name: e.detail?.data?.name,
        });
      }
    });
    this.tagify.on("remove", (e) => {
      const email = e.detail?.data?.email;
      if (email) {
        this.slcAppUserList = this.slcAppUserList.filter(
          (user) => user.email !== email
        );
      }
    });
  }
  bindTagifyUserGroups(data) {
    const inputElement = document.querySelector(
      '[name="tagsgroups"]'
    ) as HTMLInputElement | null;
    if (!inputElement) return;
    this.tagify = new Tagify(inputElement, {
      whitelist: data,
      dropdown: {
        searchKeys: ["role"],
        enabled: 0,
        closeOnSelect: !1,
        position: "text",
        highlightFirst: true,
      },
    });
    this.tagify.on("add", (e) => {
      this.slcAppUserList = [];
      this.users = [];
      let role = e.detail?.data?.role;
      this.getAppUserGroups(role);
    });

    this.tagify.on("remove", (e) => {
      let role = e.detail?.data?.role;
      this.removeAppUserGroups(role);
    });
  }
  getAppUserGroups(role) {
    if (role != "") {
      this.api
        .getUserlistByUserRoles(this.formid, role)
        .subscribe((res: any) => {
          if (res.length > 0) {
            const groupedUsers = res.reduce((groups, user) => {
              user.userRoles.forEach((role: string) => {
                if (!groups[role]) {
                  groups[role] = [];
                }
                groups[role].push({
                  id: user._id,
                  name: user.name,
                  email: user.email,
                });
              });
              return groups;
            }, {});
            const newGroups = Object.keys(groupedUsers).map((role) => ({
              label: role,
              users: groupedUsers[role],
            }));

            const deduplicatedGroups = this.slcAppUserGroups.reduce(
              (acc, existingGroup) => {
                const existingGroupIndex = newGroups.findIndex(
                  (newGroup) => newGroup.label === existingGroup.label
                );
                if (existingGroupIndex !== -1) {
                  const existingUserIds = existingGroup.users.map(
                    (user) => user.id
                  );
                  const uniqueUsers = [
                    ...existingGroup.users,
                    ...newGroups[existingGroupIndex].users.filter(
                      (user) => !existingUserIds.includes(user.id)
                    ),
                  ];
                  acc.push({
                    ...existingGroup,
                    users: uniqueUsers,
                  });
                  newGroups.splice(existingGroupIndex, 1);
                } else {
                  acc.push(existingGroup);
                }
                return acc;
              },
              []
            );

            const remainingNewGroups = newGroups.filter(
              (newGroup) =>
                !this.slcAppUserGroups.some(
                  (existingGroup) => existingGroup.label === newGroup.label
                )
            );

            this.slcAppUserGroups = [
              ...deduplicatedGroups,
              ...remainingNewGroups,
            ];
          }
        });
    }
  }
  removeAppUserGroups(role) {
    this.slcAppUserGroups = this.slcAppUserGroups.filter(
      (group) => group.label !== role
    );
  }

  getRubrics() {
    this.api.getRubricsList(this.formid).subscribe((res: any) => {
      if (res) {
        this.getUserList();
        this.getUserGroups();
        this.cmbRubrics = res.rubrics;

        if (
          this.assessmentId &&
          this.rubricId &&
          Array.isArray(this.cmbRubrics)
        ) {
          const selectedRubric = this.cmbRubrics.find(
            (rubric) =>
              rubric._id === this.rubricId ||
              rubric.id === this.rubricId ||
              (rubric["$oid"] && rubric["$oid"] === this.rubricId)
          );
          if (selectedRubric) {
            const selectedAssessment = selectedRubric;
            if (selectedAssessment) {
              this.form.get("rubrics")?.setValue(selectedAssessment._id);
            }
          } else if (this.cmbRubrics.length > 0) {
            const firstRubric = this.cmbRubrics[0];
            if (firstRubric && firstRubric.length > 0) {
              this.form.get("rubrics")?.setValue(firstRubric._id);
            }
          }
        } else if (this.cmbRubrics.length > 0) {
          this.form
            .get("rubrics")
            ?.setValue(this.cmbRubrics[0].selectedRubrics);
        }
      }
    });
  }

  radioChange(event: MatRadioChange) {
    var tagsgroup = document.querySelector('[id="ptagsgroups"]');
    var tagsuser = document.querySelector('[id="ptagsuser"]');
    if (event.value == "groups") {
      tagsuser.classList.add("hide");
      tagsgroup.classList.remove("hide");
      this.groupapp = true;
      this.userapp = false;
    } else if (event.value == "users") {
      tagsgroup.classList.add("hide");
      tagsuser.classList.remove("hide");
      this.userapp = true;
      this.groupapp = false;
    }
  }

  saveform(formstate) {
    let validform = true;
    if (this.slcUserList.length == 0 && this.slcUserGroups.length == 0) {
      this.toastr.error("Select Accessor User or Accessor Group!", "Error!");
      validform = false;
    }
    if (this.form.value.workflowname == "") {
      this.toastr.error("Enter Activity Name!", "Error!");
      validform = false;
    }
    this.getTagsData();
    if (validform) {
      const selectedRubric = this.form.get("rubrics")?.value;
      let rubricId: string | undefined;
      let assessmentId: string | undefined;
      let rubricsIndex;
      let assessmentIndex;
      let objRubrics;
      let strDateTime;

      for (
        let rubricIndex = 0;
        rubricIndex < this.cmbRubrics.length;
        rubricIndex++
      ) {
        const rubric = this.cmbRubrics[rubricIndex];
        if (rubric.selectedRubrics == selectedRubric) {
          objRubrics = { ...rubric };
          rubricId = rubric._id || rubric.id || rubric["$oid"];
          assessmentId = rubric.selectedRubrics;
        }
      }

      this.objData = {
        beginid: this.beginid,
        workflowid: this.form.value.workflowid,
        formid: this.form.value.formid,
        nodeid: this.form.value.nodeid,
        nodetype: this.nodetype,
        evaluationName: this.form.value.evaluationName,
        evaluationDate: this.form.value.evaluationDate,
        evaluationTime: this.form.value.evaluationTime,
        isuser: this.userapp,
        approveruser: this.userapp == true ? this.slcUserList : [],
        isgroup: this.groupapp,
        approvergroup: this.groupapp == true ? this.slcUserGroups : [],
        status: true,
        userid: this.api.getUserId(),
        rubrics: objRubrics,
        rubricId: rubricId,
        assessmentId: assessmentId,
      };
      if (this.beginid === 0 && formstate == "save") {
        this.api.saveEvaluation(this.objData).subscribe(
          (res: any) => {
            this.ngxService.stop();
            if (res && Number(res.responseCode) === 201) {
              this.toastr.success("Evaluation saved successfully", "Success");
              this.dialogRef.close({ cancel: false, fetch: true });
            } else {
              this.toastr.error("Evaluation failed! ", "Error!");
            }
            this.ngxService.stop();
          },
          (err) => {
            this.ngxService.stop();
            console.log(err);
          }
        );
      } else {
        this.api.updateEvaluation(this.objData, this.objData.beginid).subscribe(
          (res: any) => {
            this.ngxService.stop();
            if (res && Number(res.responseCode) === 201) {
              this.toastr.success("Evaluation updated successfully", "Success");
            } else {
              this.toastr.error("Evaluation failed! ", "Error!");
            }
            this.ngxService.stop();
          },
          (err) => {
            this.ngxService.stop();
            console.log(err);
          }
        );
      }
      this.dialogRef.close(this.form.value);
    }
  }

  getTagsData() {
    this.slcUserList = [];
    this.slcAppUserList = [];
    var taguser = document.getElementsByTagName("tag") as HTMLCollection;
    for (var i = 0; i < taguser.length; i++) {
      if (taguser[i].parentElement.classList.contains("tagsuser")) {
        this.slcUserList.push({
          id: taguser[i].getAttribute("id"),
          email: taguser[i].getAttribute("title"),
          name: taguser[i].getAttribute("name"),
        });
        this.slcAppUserList.push({
          id: taguser[i].getAttribute("id"),
          email: taguser[i].getAttribute("title"),
          name: taguser[i].getAttribute("name"),
        });
      }
      if (taguser[i].parentElement.classList.contains("tagsgroups")) {
        this.slcUserGroups.push({
          id: taguser[i].getAttribute("id"),
          role: taguser[i].getAttribute("role"),
          type: taguser[i].getAttribute("type"),
        });
      }
    }
  }

  close() {
    this.dialogRef.close();
  }
}
